import type { FaireReviewEntity } from "../../entity_types/review";

// Real brand-level review for Lemonade Shoes, read off their public Faire
// reviews list (Ryan, 2026-08-17) — verbatim comment, real reviewer, real
// rating.
export const review_ls6: FaireReviewEntity = {
  token: "review_ls6",
  type: "review",
  brandName: "Lemonade Shoes",
  brandToken: "b_mz3xxxsvnf",
  reviewType: "brand",
  reviewerName: "Kimberley",
  reviewerLocation: "Spring Hill, TN",
  stars: 5,
  reviewText:
    "Obsessed with these shoes!! The girls are already going crazy over them!",
  reviewDate: "Aug 12, 2025",
  meta: {
    source: "api",
    importedAt: "2026-08-17T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
